<template>
  <div class="createPage">
    <!-- header start -->
    <van-nav-bar 
      class="mynavbar" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <!-- header end -->

    <img src="@/assets/images/create/step00_bg.jpg" class="createBg">
    
    <div class="block">
      <img src="@/assets/images/create/creat_tips.png" class="createLogo">
      <div class="btn-area">
        <van-button round plain class="whitebtn" to="/Step01">创建纪念馆</van-button>
        <van-button round plain class="whitebtn" to="/HotHallList">关注热门馆</van-button>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    }, 
    methods :{
      onClickLeft() {
        this.$router.go(-1)
      },
    },
  }
</script>

<style scoped>
.createPage .createLogo{
  margin: 20% auto 20%;
  width:72%;
  display: block;
}
.createPage .btn-area{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.createPage .van-button{
  margin-bottom: 15px;
}
</style>
